__turbopack_context__.v({
  "bgRoot": "_1JOz_W_bgRoot",
  "content1Root": "_1JOz_W_content1Root",
  "content2Root": "_1JOz_W_content2Root",
});
